import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import { useEffect, useState } from 'react';
import { GetById_ParkingPricePeriod_Api, Update_ParkingPricePeriod_Api } from '../../API/ParkingPricePeriodApi';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';

import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// تابع کمکی برای تبدیل کاراکترهای فارسی به لاتین
const persianToLatinDigits = (str) => {
  if (!str) return '';
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  let newStr = str;
  for (let i = 0; i < 10; i++) {
    const regex = new RegExp(persianDigits[i], 'g');
    newStr = newStr.replace(regex, latinDigits[i]);
  }
  return newStr;
};

// تابع کمکی برای تبدیل رشته تاریخ از API (با اعداد لاتین) به DateObject
const latinToPersianDateObject = (dateString) => {
  if (!dateString) return null;
  return new DateObject({
    date: dateString,
    format: "YYYY-MM-DD",
    calendar: persian
  });
};

// تابع کمکی برای تبدیل DateObject به رشته با فرمت و اعداد لاتین برای API
const formatDateForApi = (dateObject) => {
  if (!dateObject) return '';
  const formattedDate = dateObject.format('YYYY-MM-DD');
  return persianToLatinDigits(formattedDate);
};

export const EditParkingPricePeriodComponent = ({ id, setLoading, showMessage, rowUpdated, cancelEdit }) => {
  const [parkingPricePeriod, setParkingPricePeriod] = useState(null);
  const [form] = Form.useForm();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const data = await GetById_ParkingPricePeriod_Api(id);
      setLoading(false);
      if (data.messageStatus === "Successful") {
        const periodData = data.messageData.data;

        const convertedFromDate = latinToPersianDateObject(periodData.from_Shamsi);
        const convertedToDate = latinToPersianDateObject(periodData.to_Shamsi);

        setFromDate(convertedFromDate);
        setToDate(convertedToDate);
        setParkingPricePeriod(periodData);

        form.setFieldsValue({
          ...periodData,
          from_Shamsi: formatDateForApi(convertedFromDate),
          to_Shamsi: formatDateForApi(convertedToDate)
        });
      } else {
        showMessage(data.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error");
    }
  };

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      values.id = id;
      // مقادیر تاریخ از Form.Item مستقیماً در values هستند
      let data = await Update_ParkingPricePeriod_Api(values);
      setLoading(false);

      if (data.messageStatus === "Successful") {
        showMessage(data.message, "Successful");
        rowUpdated();
      } else {
        showMessage(data.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error");
    }
  };

  const onFinishFailed = (errorInfo) => {
    showMessage(errorInfo, "error");
  };

  return (
    <>
      {parkingPricePeriod ? (
        <>
          <div className='sectionTitle'>
            <h2>
              ویرایش {parkingPricePeriod.title}
            </h2>
          </div>
          <div className='container'>
            <Form
              form={form}
              name="basic"
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
              onFinish={onSubmit}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="categoryId"
                hidden={true}
              />
              <Form.Item
                name="title"
                label="عنوان"
                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
              >
                <Input placeholder='عنوان' />
              </Form.Item>
              <Form.Item
                name="from_Shamsi"
                label="از تاریخ"
                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                getValueFromEvent={(value) => {
                  setFromDate(value);
                  return formatDateForApi(value);
                }}
              >
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  value={fromDate}
                  onChange={(value) => setFromDate(value)}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
              <Form.Item
                name="to_Shamsi"
                label="تا تاریخ"
                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                getValueFromEvent={(value) => {
                  setToDate(value);
                  return formatDateForApi(value);
                }}
              >
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  value={toDate}
                  onChange={(value) => setToDate(value)}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
              <Form.Item
                name="price"
                label="قیمت"
              >
                <InputNumber />
              </Form.Item>
              <Form.Item
                name="orderIndex"
                label="ترتیب"
              >
                <InputNumber />
              </Form.Item>
              <Form.Item
                name="isActive"
                valuePropName='checked'
                label="فعال"
              >
                <Checkbox />
              </Form.Item>
            </Form>
          </div>
          <Row className='sectionFooter'>
            <Col xs={0} sm={0} md={8} lg={16} xl={16} />
            <Col xs={12} sm={12} md={8} lg={4} xl={4}>
              <Button
                style={{ width: '98%' }}
                className='btn-primary'
                htmlType="submit"
                onClick={() => form.submit()}
              >
                <CheckOutlined />
                ذخیره
              </Button>
            </Col>
            <Col xs={12} sm={12} md={8} lg={4} xl={4}>
              <Button
                className='btn-secondary'
                style={{ width: '100%' }}
                onClick={() => cancelEdit()}
              >
                <RollbackOutlined />
                لغو
              </Button>
            </Col>
          </Row>
        </>
      ) : (<></>)}
    </>
  );
};